"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wixMediaUrlFactory = exports.wixMediaUrlTransformationPlugin = void 0;
var context_1 = require("./context");
var consts_1 = require("../consts");
var imageClientLib = require('image-client-api/dist/imageClientApi');
function wixMediaUrlTransformationPlugin(str) {
    return str.replace(/url\("(.*?)"\)/g, function (origin, _url) {
        var urlObj = new URL(_url);
        var formatterValues = urlObj.searchParams.get(consts_1.wixMediaUrlFormatterOriginalArgsParamname);
        if (formatterValues) {
            return "".concat(consts_1.wixMediaUrlFormatter, "(").concat(formatterValues, ")");
        }
        else {
            return origin;
        }
    });
}
exports.wixMediaUrlTransformationPlugin = wixMediaUrlTransformationPlugin;
function addOriginalFormatterArgsToUrl(imageUrl, args) {
    var paramsPrefix = (imageUrl.includes('?')) ? '&' : '?';
    return "".concat(imageUrl).concat(paramsPrefix).concat(consts_1.wixMediaUrlFormatterOriginalArgsParamname, "=").concat(args.join(','));
}
function wixMediaUrlFactory() {
    return function (uri, originalWidth, originalHeight) {
        var width = Number.parseInt(originalWidth, 10);
        var height = Number.parseInt(originalHeight, 10);
        // Optimize target size:
        var layout = context_1.inlineModulesContext.uriToLayoutMap[uri];
        // Default: target size is same as origin size:
        var targetWidth = (layout) ? layout.width : width;
        var targetHeight = (layout) ? layout.height : height;
        var result = imageClientLib.getData(imageClientLib.fittingTypes.SCALE_TO_FILL, {
            id: uri,
            width: width,
            height: height
        }, {
            width: targetWidth,
            height: targetHeight,
            htmlTag: imageClientLib.htmlTag.BG,
            alignment: 'center'
        });
        var imageUrl = context_1.inlineModulesContext.staticMediaUrl + '/' + result.uri;
        if (context_1.inlineModulesContext.shouldUseWebp && result.uri.match(/((.jpg)|(.jpeg)|(.png))$/)) {
            imageUrl = imageUrl.concat('.webp');
        }
        imageUrl = addOriginalFormatterArgsToUrl(imageUrl, [uri, originalWidth, originalHeight]);
        return "url(\"".concat(imageUrl, "\")");
    };
}
exports.wixMediaUrlFactory = wixMediaUrlFactory;
exports.default = wixMediaUrlFactory();
//# sourceMappingURL=wix-media-url.js.map